module.exports = __webpack_public_path__ + "img/linreg.b8aeb4d8.png";